module.exports = __webpack_public_path__ + "img/11_31.a07741f8.png";